import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JtsSidebarMenuService } from '../jts-sidebar-menu.service';

@Component({
  selector: 'lib-report-an-issue',
  templateUrl: './report-an-issue.component.html',
  styleUrls: ['./report-an-issue.component.css'],
})
export class ReportAnIssueComponent implements OnInit {
  @Input() djjUserAcID = null;
  @Input() juvenileID = null;
  @Input() sitLocationCode = null;
  @Output() close = new EventEmitter();
  submitted = false;
  issueID: any = null;
  isLoading = false;
  constructor(private jtsSidebarMenuService: JtsSidebarMenuService) {}
  issueToReport = '';
  copyMe = false;
  ngOnInit(): void {
    console.log(this.djjUserAcID);
    console.log(this.juvenileID);
    console.log(this.sitLocationCode);
    this.submitted = false;
  }

  submitIssue() {
    this.isLoading = true;
    const reportAnIssueModel = {
      JuvenileId: this.juvenileID ?? -1,
      TaIssueToReport: this.issueToReport,
      SitLocationCode: this.sitLocationCode ?? -1,
      JtsReportAnIssueCopyUser: this.copyMe === true ? 1 : 0,
      DJJUserAcID: this.djjUserAcID ?? -1,
    };

    this.jtsSidebarMenuService
      .reportAnIssue(reportAnIssueModel)
      .subscribe((response: any) => {
        this.isLoading = false;
        this.issueID = response;
        this.submitted = true;
      },
      (error) => {
        this.isLoading = false;
        alert('Failed to submit the issue. Please try again.');
      });
  }

  closeWindow() {
    this.close.emit();
  }
}
